// types
import { type ModuleType as Remenders } from "./_definitions"
import { type State } from "../../types"

export const remendersSelector = (state: State): Remenders => state.remenders
